// captureMessage :: forall r. String -> { | r } -> Effect Unit
export function captureMessage(message) {
  return function (extra) {
    return function () {
      if (!window.Raven) {
        console.error(
          "[Raven.captureMessage - Raven not set up]",
          message,
          extra
        );
        return;
      }
      Raven.captureMessage(message, extra);
    };
  };
}
